import * as types from "./types";

interface ActiveMenuState {
  orders: {
    menu_id: string;
    quantity: number;
  }[];
  countState: boolean;
  totalAmount: number;
  menuItems: any[];
  menuItemLoading: boolean;
  menuItemError: any;
}

export const ActiveMenuInitialState: ActiveMenuState = {
  orders: [],
  totalAmount: 0,
  countState: false,
  menuItems: [],
  menuItemLoading: false,
  menuItemError: null,
};

export const activeMenuReducer = (
  state = ActiveMenuInitialState,
  action: any
) => {
  // console.log(state);
  switch (action.type) {
    case types.LIST_ACTIVE_MENU_FETCH_START:
      return {
        ...state,
        menuItemLoading: true,
      };
    case types.LIST_ACTIVE_MENU_FETCH_SUCCESS:
      // console.log("success");
      // console.log(action.menuItems.data);
      return {
        ...state,
        menuItems: action.menuItems,
        // categories:[ ...state.categories,state.categories.category_id:action.payload]

        menuItemLoading: false,
      };

    case types.LIST_ACTIVE_MENU_FETCH_FAILURE:
      return {
        ...state,
        menuItemError: action.menuItemError,
        menuItemLoading: false,
      };

    case types.ADD_ORDER:
      const menuId = action.menu_id;
      // console.log("i am added menuId", menuId);
      // console.log("i am added orders", state.orders);
      const isInOrders = state?.orders?.some(
        (order) => order.menu_id === menuId
      );

      if (isInOrders) {
        if (action.count >= action.quantity) {
          return {
            ...state,
            totalAmount: state.totalAmount,
          };
        }
        // update existing order in orders
        return {
          ...state,
          totalAmount: state.totalAmount + action.rate,
          orders: state.orders.map((order) =>
            order.menu_id === menuId
              ? {
                  ...order,
                  menu_id: menuId,
                  quantity: order.quantity + 1,
                }
              : order
          ),
        };
      }
      // console.log("i am added orders after logic", state.orders);
      return {
        ...state,
        countState: false,
        totalAmount: state.totalAmount + action.rate,
        orders: [
          ...state.orders,
          {
            menu_id: menuId,
            quantity: 1,
          },
        ],
      };

    case types.REMOVE_ORDER:
      const menuIdR = action.menu_id;
      console.log("i am added menuId", menuIdR);
      console.log("i am added orders", state.orders);
      const isInOrdersD = state.orders.some(
        (order) => order.menu_id === menuIdR
      );

      const order = state.orders.find((item) => item.menu_id === menuIdR);
      if (order?.quantity === 1) {
        // new quantity is 0, remove item from cart
        return {
          ...state,
          totalAmount: state.totalAmount - action.rate,
          orders: state.orders.filter((item) => item.menu_id !== menuIdR),
        };
      }
      if (state.totalAmount <= 0) {
        return {
          ...state,
          totalAmount: 0,
        };
      }

      if (!isInOrdersD) {
        return {
          ...state,
          totalAmount: state.totalAmount,
        };
      }

      return {
        ...state,
        countState: false,
        totalAmount: state.totalAmount - action.rate,
        orders: state.orders.map((order) =>
          order.menu_id === menuIdR
            ? {
                ...order,
                menu_id: menuIdR,
                quantity: order.quantity - 1,
              }
            : order
        ),
      };

    case types.RESET_ORDER:
      return {
        ...state,
        countState: true,
        orders: [],
        totalAmount: 0,
      };

    default:
      return state;
  }
};
